export const databasesActions = {
    GET_SCHEMAS: 'GET_SCHEMAS',
    SET_SCHEMAS: 'SET_SCHEMAS',
    GET_SCHEMA_PROPERTIES:'GET_SCHEMA_PROPERTIES',
    SET_SCHEMA_PROPERTIES:'SET_SCHEMA_PROPERTIES',
    SAVE_SCHEMA_PROPERTIES:'SAVE_SCHEMA_PROPERTIES',
    TEST_CONNECT_TO_SCHEMA:'TEST_CONNECT_TO_SCHEMA',
    TEST_CONNECT_STATUS:'TEST_CONNECT_STATUS',
    TEST_CONNECT: 'TEST_CONNECT',
    GET_CONN_TEMPLATE: 'GET_CONN_TEMPLATE',
    SWITCH_TAB:'SWITCH_TAB',
    RESET_SCHEMAS_TEST_CONNECT_STATUS:'RESET_SCHEMAS_TEST_CONNECT_STATUS',
    RESET_SCHEMAS_PROPERTIES:'RESET_SCHEMAS_PROPERTIES'
};

const initState = {
    items: []
};

export const databasesReducer = (state = initState, action: any) => {
    switch (action.type) {
        case databasesActions.SET_SCHEMAS:
        case databasesActions.SET_SCHEMA_PROPERTIES:
        case databasesActions.TEST_CONNECT_STATUS:
        case databasesActions.TEST_CONNECT:
            return Object.assign({}, state, action.payload);

        case databasesActions.RESET_SCHEMAS_TEST_CONNECT_STATUS:
            return Object.assign({}, state, { status_test_schema: null });

        case databasesActions.RESET_SCHEMAS_PROPERTIES:
            return Object.assign({}, state, { schemaProperties:null, items:[] });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/databasesReducer.ts